import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";
import {UntypedFormControl, Validators} from "@angular/forms";

@Component({
  selector: 'ep-delivery-point-list',
  templateUrl: './delivery-point-list.component.html',
  styleUrls: ['./delivery-point-list.component.scss']
})
export class DeliveryPointListComponent {

  @Input() deliveryPoints?: DeliveryPoint[] | null = []

  @Input() selectedDeliveryPointControl = new UntypedFormControl(null,Validators.required);

  @Input() hasDeleteButton: boolean = false;

  @Output() onClickDeleteButton = new EventEmitter<DeliveryPoint>();

  @Input() radioButtonName?: string = 'selected-delivery-point';

  @Input() isLoading?: boolean | null = false;

  trackByCode(index:number, deliveryPoint: DeliveryPoint): number {
    return deliveryPoint.code;
  }

}
